import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { InputField, type InputFieldProps } from "../InputField";

import styles from "./PasswordField.module.css";

type PasswordFieldProps = Omit<InputFieldProps, "rightAccessory" | "type">;

export const PasswordField = (props: PasswordFieldProps) => {
	const { t } = useTranslation("common");
	const [isVisible, setIsVisible] = useState(false);

	const onBtnClick = useCallback(() => setIsVisible((value: boolean) => !value), []);

	const rightAccessory = useMemo(
		() => (
			<button
				aria-label={isVisible ? t("passwordField.hide") : t("passwordField.show")}
				className={styles.toggle}
				onClick={onBtnClick}
				type="button">
				<svg aria-hidden="true" className={styles.icon} fill="none" viewBox="0 0 24 24">
					<path
						d="M2.75 12s3.2-6.25 9.25-6.25S21.25 12 21.25 12 18.05 18.25 12 18.25 2.75 12 2.75 12Z"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.8"
					/>
					<path
						d="M12 14.75a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5Z"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.8"
					/>
				</svg>
			</button>
		),
		[isVisible, onBtnClick, t]
	);

	return <InputField rightAccessory={rightAccessory} type={isVisible ? "text" : "password"} {...props} />;
};
